import initGgm from './initGTM';

const initAnalytics = () => {
  const { hostname } = window.location;
  const isProd = hostname.endsWith('.com');
  const isStage = hostname.endsWith('.dev');

  if (isProd || isStage) {
    initGgm(isProd ? 'GTM-PRMQN7C' : 'GTM-WZQNMJX');
  }
};

export default initAnalytics;
